import { z } from "zod";
import { SYSTEMS_PER_GALAXY } from "../constants/resources.js";
import { FleetShipsSchema } from "./fleet.schemas.js";
import { PlayerRaceSchema } from "./user.schemas.js";
/**
 * Request schemas for the Sun control endpoints. Shape only — who may
 * recall what, and how much must stay behind, is decided server-side
 * (`planSunGarrisonRecall`, `packages/game-engine/src/sunControl.ts`).
 */
/** `/recallSunGarrison` — bring part of a Sun's garrison home to the Team planet. */
export const RecallSunGarrisonSchema = z.object({
    galaxy: z.number().int().min(1).max(999),
    system: z.number().int().min(1).max(SYSTEMS_PER_GALAXY),
    /** Which race's garrison lane the ships come from — the Team planet lane they dock back into. */
    race: PlayerRaceSchema,
    ships: FleetShipsSchema,
});
//# sourceMappingURL=sun.schemas.js.map